/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2020-07-01 10:06:38
 * @LastEditors: voanit
 * @LastEditTime: 2020-11-25 13:20:46
 */
import { mapActions, mapState } from 'vuex'
export default {
  methods: {
    ...mapActions(['addCache', 'delCache'])
  },
  computed: {
    ...mapState({
      cacheList: state => state.cache.cacheList
    })
  },
  beforeRouteLeave(to, from, next) {
    if (from.meta.keepAlive && !from.meta.isClose) {
      let obj = {
        page: undefined,
        pageSize: undefined
      }
      let hasParams = false
      let searchBox = this.$children.filter(item => item.$refs.searcBox)
      let pageBox = this.$children.filter(item => item.$refs.pageBox)
      if (searchBox && searchBox.length === 1) {
        let r = searchBox[0]
        obj.isSearch = r.isSearch
        obj.commit = r.commit
        obj.socpeList = r.socpeList
        obj.openTit = r.openTit
        obj.openbel = r.openbel
        obj.name = this.$route.name
        hasParams = r.headSearch('hasParams')
      }
      if (pageBox && pageBox.length === 1) {
        let r = pageBox[0]
        obj.pageSize = r.pageSize
        obj.page = r.page
      }
      if (Object.keys(obj).length > 2) {
        if (hasParams && obj.page == 1 && obj.pageSize == 50 && obj.openbel) {
          this.delCache(obj.name)
        } else {
          this.addCache(obj)
        }
      }
    }
    next()
  }
}
